import React from 'react';

interface Address {
  guestName: string;
  postalAddress: string;
  phoneNumber?: string; // 新增電話號碼欄位
}

interface MailingLabelPrintPageProps {
  addresses: Address[];
  includePhone?: boolean; // 新增是否包含電話號碼的選項
}

export const MailingLabelPrintPage: React.FC<MailingLabelPrintPageProps> = ({ addresses, includePhone = false }) => {
  // 將地址分組，每頁 14 個標籤
  const labelsPerPage = 14;
  const totalPages = Math.ceil(addresses.length / labelsPerPage);
  const addressPages = [];
  
  for (let i = 0; i < totalPages; i++) {
    const startIndex = i * labelsPerPage;
    const endIndex = startIndex + labelsPerPage;
    addressPages.push(addresses.slice(startIndex, endIndex));
  }

  return (
    <html lang="zh-TW">
      <head>
        <meta charSet="UTF-8" />
        <title>郵寄標籤列印 - Avery 99x38mm</title>
        <script src="https://cdn.tailwindcss.com"></script>
        <style>
          {
            `
            @media print {
              body {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
              .no-print {
                display: none;
              }
              @page {
                size: A4;
                margin: 0;
              }
              .page-break {
                page-break-after: always;
              }
            }
            body {
              font-family: sans-serif;
            }
            .label-container {
              display: grid;
              grid-template-columns: repeat(2, 99mm);
              grid-template-rows: repeat(7, 38mm);
              justify-content: center;
              align-content: center;
              width: 210mm;
              height: 297mm;
              box-sizing: border-box;
              /* Avery L7163-like margins */
              padding: 15.1mm 4.65mm;
              gap: 0;
            }
            .label {
              border: 1px dotted #ccc; /* 裁切輔助線 */
              padding: 4mm;
              box-sizing: border-box;
              overflow: hidden;
              font-size: 12pt;
              line-height: 1.4;
              display: flex;
              flex-direction: column;
              justify-content: center;
              word-wrap: break-word; /* 確保文字會換行 */
            }
            .label-line {
              /* 移除 no-wrap 屬性以允許換行 */
            }
            .label-title {
              font-weight: bold;
            }
            `
          }
        </style>
      </head>
      <body>
        <div className="p-4 no-print">
          <h1 className="text-xl font-bold mb-2">郵寄標籤預覽</h1>
          <p className="text-gray-600">格式：Avery 14格 (99mm x 38mm)</p>
          <p className="text-gray-600 mt-1">共 {addresses.length} 筆地址，將列印 {totalPages} 頁</p>
          <p className="text-gray-600 mt-1">如果列印視窗沒有自動開啟，請手動按 Ctrl/Cmd + P。</p>
        </div>
        
        {addressPages.map((pageAddresses, pageIndex) => (
          <div key={pageIndex} className={`label-container ${pageIndex < totalPages - 1 ? 'page-break' : ''}`}>
            {pageAddresses.map((addr, index) => (
              <div key={index} className="label">
                <div className="label-line">
                  <span className="label-title">收件人：</span>{addr.guestName}
                </div>
                <div className="label-line">
                  <span className="label-title">地址：</span>{addr.postalAddress}
                </div>
                {includePhone && addr.phoneNumber && (
                  <div className="label-line">
                    <span className="label-title">電話：</span>{addr.phoneNumber}
                  </div>
                )}
              </div>
            ))}
            {/* 填充剩餘的空白標籤以保持網格結構 */}
            {Array.from({ length: Math.max(0, labelsPerPage - pageAddresses.length) }).map((_, index) => (
              <div key={`placeholder-${index}`} className="label"></div>
            ))}
          </div>
        ))}
      </body>
    </html>
  );
};
